import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { navigationLinks, companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header className="header-industrial">
      {/* Top Bar */}
      <div className="header-topbar">
        <div className="container-main">
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-6">
              <a href={`mailto:${companyInfo.email}`} className="header-contact-item">
                <Mail size={16} />
                <span>{companyInfo.email}</span>
              </a>
              <a href={`tel:${companyInfo.phone}`} className="header-contact-item">
                <Phone size={16} />
                <span>{companyInfo.phone}</span>
              </a>
            </div>
            <div className="hidden md:block">
              <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                Mon - Fri: 9:00 AM - 6:00 PM
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className={`header-main ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container-main">
          <nav className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="header-logo">
              <div className="logo-icon">C</div>
              <div className="logo-text">
                <span className="logo-name">{companyInfo.name}</span>
                <span className="logo-tagline">Engineering Excellence</span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-6">
              {navigationLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`header-nav-link ${location.pathname === link.path ? 'active' : ''}`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <Link to="/contact" className="btn-industrial-primary" style={{ padding: '0.875rem 2rem' }}>
                Get Quote
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden mobile-menu-btn"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </nav>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-industrial">
          <div className="container-main">
            <div className="flex flex-col gap-3 py-6">
              {navigationLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" className="btn-industrial-primary w-full text-center mt-4">
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
